import 'magnific-popup';

export default () => {
  $(document).ready(function() {
    $('.gl-lightbox-img').magnificPopup({
      type: 'image',
      gallery:{
        enabled:true
      }
    });
  });
};


/** WEBPACK FOOTER **
 ** ./assets/src/js/magnific-popup/magnific-popupInit.js
 **/